import React, { type ReactNode } from 'react';
import { Stack, xcss } from '@atlaskit/primitives';

const DependencyCardContainer = ({ children }: { children: ReactNode }) => (
	<Stack xcss={dependencyCardContainerStyles}>{children}</Stack>
);

export default DependencyCardContainer;

const dependencyCardContainerStyles = xcss({
	borderRadius: 'border.radius',
	borderWidth: '1px',
	borderStyle: 'solid',
	borderColor: 'color.border',
});
